import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable()
export class MerchantBulkCreateService {
  private BASE_URL = 'oc-api/operations/merchants-bulk-management/creation'

  constructor(private http: HttpClient) {
  }

  create(file: File) {
    const formData: FormData = new FormData();
    formData.append('attachment', file, file.name);

    return this.http.post(this.BASE_URL, formData);
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-bulk-create/merchant-bulk-create.service.ts